var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbrappMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 171,
    viewBox: "0 0 220 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M156.17 106.49C123.2 105.67 87.73 98.42 60.42 74.33C51.48 66.44 41.63 55.14 36.57 42.12H0C2.84 53.39 10.04 63.63 16.79 71.48C38.22 96.43 68.54 107.08 97.09 111.53C116.69 114.58 136.45 114.33 156.17 114.25V106.49Z",
    fill: "#0055B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M181.62 156.65C191.97 165.39 205.5 167.85 217.94 168.02L219.43 170.73C211.32 170.73 203.18 170.98 195.12 169.78C184.6 168.21 173.43 164.45 165.53 155.65C163.04 152.88 160.39 149.27 159.34 145.3H159.33L121.9 39.92H121.82L121.22 38.19C118.68 30.72 115.79 20.55 115.62 20.55H115.45C115.28 20.55 112.4 30.72 109.85 38.19L109.25 39.92H109.18L71.7396 145.3H57.5596L109.18 0H121.91L173.53 145.29C175.39 149.88 178.33 153.87 181.62 156.65Z",
    fill: "#004A98"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbrappMini);
export default __webpack_public_path__ + "static/media/AbrappMini.b2b12420604f7acaf2b5700958801e42.svg";
export { ForwardRef as ReactComponent };